import { Component, OnInit, ChangeDetectorRef, ViewChild, ElementRef } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { UserService } from 'src/app/services/user.service';
import { NgxSpinnerService } from 'ngx-spinner';
import * as FormActions from '../../reducers/actions/forms.actions';
import { Form, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { PerfilComponent } from '../perfil/perfil.component';
import * as moment from 'moment';
// import { forEach } from '@angular/router/src/utils/collection';
import { isNull } from 'util';
import { isEmpty } from 'rxjs/operators';
import { fadeOutCollapseOnLeaveAnimation } from 'angular-animations';
import * as jspdf from 'jspdf';
import html2canvas from 'html2canvas';
import { Router } from '@angular/router';
import { Seguimiento_exp_Service } from 'src/app/services/seguimiento_exp.service';
import { RutValidator } from 'ng9-rut';
import { ClaveUnicaService } from 'src/app/services/clave_unica.service';




declare const swal: any;

interface AppState {
  form: Form;
}

@Component({
  selector: 'app-seguimiento-expediente',
  templateUrl: './seguimiento-expediente.component.html',
  styleUrls: ['./seguimiento-expediente.component.css'],
  providers: [Seguimiento_exp_Service, ClaveUnicaService]

})
export class SeguimientoExpedienteComponent implements OnInit {

  public expediente_info
  public link_acta
  public arreglo
  buscando = false
  public numSol = new FormControl('', [Validators.required]);
  public rut = new FormControl('', [Validators.required]);
  public fecha_ingreso = new FormControl('', [Validators.required]);
  public expa1 = true
  public expa2 = true
  public expa3 = true
  public expa4 = true
  public expa5 = true
  public colorExpa1 = "#01BAC9"
  public colorExpa2 = "#01BAC9"
  public colorExpa3 = "#01BAC9"
  public colorExpa4 = "#01BAC9"
  public colorExpa5 = "#01BAC9"
  public exp_form


  public link_acta2 = "acta-expediente?id="

  //@ViewChild('htmlpdf') content: ElementRef;

  identity
  token

  constructor(
    private _snackBar: MatSnackBar,
    private dialog: MatDialog,
    private store: Store<AppState>,
    private _exp: Seguimiento_exp_Service,
    private spinner: NgxSpinnerService,
    private _cd: ChangeDetectorRef,
    private _router: Router,
    private _formBuilder: FormBuilder,
    private _rutvalidator: RutValidator,
    private _userService: UserService,
    private claveUnicaService: ClaveUnicaService
  ) {
    console.log("SeguimientoExpedienteComponent")

    this.exp_form = this._formBuilder.group({
      rut: ['', [Validators.required, this._rutvalidator]],
      numSol: ['', [Validators.required]],

    });
  }

  ngOnInit() {
    this.identity = this._userService.getIdentity();
    this.token = this._userService.getToken();
  }

  get_expediente() {
    this.spinner.show()
    var rut_new = this.exp_form.controls.rut.value
    rut_new = rut_new.slice(0, -1)
    this._exp.get_expediente(this.exp_form.controls.numSol.value, rut_new).subscribe(response => {


      console.log("response: ", response)
      var fechax, fechay, peso1, peso2
      if (response.expediente.length > 0) {

        this.spinner.hide()

        this.expediente_info = response.expediente
        this.buscando = true
        console.log(this.expediente_info)

        /* fecha creacion */
        fechax = this.expediente_info[0].fieldData['TEd_FechaCreacion']
        fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
        if (fechay == "Invalid date") { fechay = "" }
        this.expediente_info[0].fieldData['TEd_FechaCreacion'] = fechay

        /* fecha acta */
        fechax = this.expediente_info[0].fieldData['TEd_Acta_Fecha_4_VB_Jefe']
        fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
        if (fechay == "Invalid date") {
          fechay = ""
        }
        this.expediente_info[0].fieldData['TEd_Acta_Fecha_4_VB_Jefe'] = fechay

        /* fecha notificacion acta */
        fechax = this.expediente_info[0].fieldData['TEd_Acta_Fecha_Notificacion']
        fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
        if (fechay == "Invalid date") {
          fechay = ""
        }
        this.expediente_info[0].fieldData['TEd_Acta_Fecha_Notificacion'] = fechay

        /* fecha reingreso acta */
        fechax = this.expediente_info[0].fieldData['TEd_Acta_Fecha_9_Reingreso_Acta']
        fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
        if (fechay == "Invalid date") {
          fechay = ""
        }
        this.expediente_info[0].fieldData['TEd_Acta_Fecha_9_Reingreso_Acta'] = fechay

        /* fecha notificacion calculo */
        fechax = this.expediente_info[0].fieldData['TUr_Acta_6_Cal_Notifica_Pago']
        fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
        if (fechay == "Invalid date") {
          fechay = ""
        }
        this.expediente_info[0].fieldData['TUr_Acta_6_Cal_Notifica_Pago'] = fechay

        /* fecha autoriza calculo */
        fechax = this.expediente_info[0].fieldData['TUr_Acta_5_Cal_Autoriza_Pago']
        fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
        if (fechay == "Invalid date") {
          fechay = ""
        }
        this.expediente_info[0].fieldData['TUr_Acta_5_Cal_Autoriza_Pago'] = fechay

        /* fecha */
        fechax = this.expediente_info[0].fieldData['TEd_Exp_Fecha']
        fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
        if (fechay == "Invalid date") {
          fechay = ""
        }
        this.expediente_info[0].fieldData['TEd_Exp_Fecha'] = fechay

        fechax = this.expediente_info[0].fieldData['TEd_Rechazo_Fecha']
        fechay = moment(new Date(fechax)).format("DD/MM/YYYY")
        if (fechay == "Invalid date") {
          fechay = ""
        }
        this.expediente_info[0].fieldData['TEd_Rechazo_Fecha'] = fechay


        const formatterPeso = new Intl.NumberFormat('es-CL', {
          style: 'currency',
          currency: 'CLP',
          minimumFractionDigits: 0
        })




        peso1 = this.expediente_info[0].fieldData.TEd_CD_Total_Pagar



        peso2 = formatterPeso.format(peso1)
        if (peso2 != "$NaN") {
          this.expediente_info[0].fieldData.TEd_CD_Total_Pagar = peso2
        } else {
          this.expediente_info[0].fieldData.TEd_CD_Total_Pagar = "$0"
        }

        if (this.expediente_info[0].fieldData['Administracion 2::Adm_Nom_Completo'] == "" && this.expediente_info[0].fieldData['Administracion 2::Adm_Fono'] == "" && this.expediente_info[0].fieldData['Administracion 2::Adm_Mail'] == "") {
          this.colorExpa1 = "titleExpaB"
        } else {
          this.colorExpa1 = "titleExpaA"
        }

        if (this.expediente_info[0].fieldData['TEd_Acta_Fecha_4_VB_Jefe'] == "" && this.expediente_info[0].fieldData['TEd_Acta_Fecha_Notificacion'] == "" && this.expediente_info[0].fieldData['TEd_Acta_Fecha_9_Reingreso_Acta'] == "") {
          this.colorExpa2 = "titleExpaB"
        } else {
          this.colorExpa2 = "titleExpaA"
        }

        if (this.expediente_info[0].fieldData['TUr_Acta_5_Cal_Autoriza_Pago'] == "" && this.expediente_info[0].fieldData['TUr_Acta_6_Cal_Notifica_Pago'] == "") {
          this.colorExpa3 = "titleExpaB"
        } else {
          this.colorExpa3 = "titleExpaA"
        }


        if (this.expediente_info[0].fieldData['TEd_Exp_Numero'] == "" && this.expediente_info[0].fieldData['TEd_Exp_Fecha'] == "") {
          this.colorExpa4 = "titleExpaB"
        } else {
          this.colorExpa4 = "titleExpaA"
        }

        if (this.expediente_info[0].fieldData['TEd_Rechazo_Numero'] == "" && this.expediente_info[0].fieldData['TEd_Rechazo_Fecha'] == "") {
          this.colorExpa5 = "titleExpaB"
        } else {
          this.colorExpa5 = "titleExpaA"
        }


        this.spinner.hide()
      } else {
        this.spinner.hide()
        swal({
          type: 'warning',
          title: 'Atención!',
          text: "No se encontraron registros de certificados con ese numero de solicitud",
          confirmButtonColor: '#3F51B5',
          confirmButtonText: 'Aceptar',
          timer: 3500
        }).then(() => {
        }, (dismiss) => {
          if (dismiss === 'timer') {
          }
        });
      }

    }, error => {
      console.log(error)
    })

  }




  async logout() {
    this.store.dispatch(new FormActions.FormUpdate('0', ''))
    sessionStorage.removeItem("identity-domCloud");
    sessionStorage.removeItem("token-domCloud");
    this._router.navigate(['/inicio']);
    const response = await this.claveUnicaService.logoutClaveUnica()
    console.log('Deslogeo exitoso:', response);

    this._snackBar.open("Se ha cerrado sesión", "Cerrar", {
      duration: 3000,
    });
  }

  openPerfil() {
    this.dialog.open(PerfilComponent)
  }

  volver() {
    this.buscando = false
    this.exp_form.controls.numSol.setValue("")
    this.exp_form.controls.rut.setValue("")

  }

}
